import { IRequestFetcherOptions } from "src/common/razzle-platform-components/types"
import axios from 'src/common/razzle-platform-components/axios'
import {BASE_API_URL, REVIEWS_OF_PURCHASE_ITEM_API_END_POINT} from 'src/common/razzle-platform-reviewofpurchaseitem/configs'


export const fetchReviewsOfPurchaseItem = async (id: string, options: IRequestFetcherOptions={params: null, useUrlParams: true, usePagination: true, searchParams: null }) => {

    let params = {
        _page: '1',
        _per_page: '8',
    }

    if (options.useUrlParams) {
        params = { ...params, ...options.searchParams }
    }

    if (options.params) {
        params = {...params, ...options.params}
    }

    if (options.usePagination === false) {
        delete params._page
        delete params._per_page
    }

    const response = await axios.get(`${BASE_API_URL}${REVIEWS_OF_PURCHASE_ITEM_API_END_POINT}/${id}`, {params})

    const count = parseInt(response.headers['x-total-count'], 10)

    const pagination = {
        count,
        page: parseInt(params._page || '1', 10),
        perPage: options.usePagination ? parseInt(params._per_page, 10) : count,
    }

    return { reviews: response.data, pagination }
}


export const fetchReviewsOfPurchaseItems = async (options: IRequestFetcherOptions={params: null, useUrlParams: true, usePagination: true, searchParams: null }) => {

    let params = {
        _page: '1',
        _per_page: '8',
    }

    if (options.useUrlParams) {
        params = { ...params, ...options.searchParams }
    }

    if (options.params) {
        params = {...params, ...options.params}
    }

    if (options.usePagination === false) {
        delete params._page
        delete params._per_page
    }

    const response = await axios.get(`${BASE_API_URL}${REVIEWS_OF_PURCHASE_ITEM_API_END_POINT}`, {params})

    const count = parseInt(response.headers['x-total-count'], 10)

    const pagination = {
        count,
        page: parseInt(params._page || '1', 10),
        perPage: options.usePagination ? parseInt(params._per_page, 10) : count,
    }
    return { reviews: response.data, pagination}
}